export default __webpack_public_path__ + "static/media/Non-constructive-Messenger.e833cc74.gif";